import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpService } from './http.service';
import { User } from '../models/user/user.model';
import { StorageService } from './storage.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable, Output, EventEmitter } from '@angular/core';

export interface UserSessionEvent {
  hasSignedIn: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  @Output() userChange = new EventEmitter<boolean>();

  private jwtHelper: JwtHelperService;
  private user: BehaviorSubject<any>;

  private userSession: Subject<UserSessionEvent> = new Subject<UserSessionEvent>();
  public userSession$: Observable<UserSessionEvent> = this.userSession.asObservable();

  constructor(
    private http: HttpService,
    private storage: StorageService
  ) {
    this.jwtHelper = new JwtHelperService();
    this.user = new BehaviorSubject({} as any);
  }

  isLogged = (): boolean => !!this.storage.getToken();

  // The CMS user lives in the session token; see `getLocalUser`.
  setLocalUser(sessionToken: string) {
    this.storage.setToken(sessionToken);
    this.userSession.next({ hasSignedIn: true });
  }

  clearUser() {
    this.user = new BehaviorSubject({} as any);
    this.storage.removeToken();
    this.userSession.next({ hasSignedIn: false });
  }

  getUserDetail(objectId) {
    return this.http.get('users/' + objectId);
  }

  getLocalUser(): User {
    return this.jwtHelper.decodeToken(this.storage.getToken());
  }
}
